// extracted by mini-css-extract-plugin
export default {"container":"ExpandCard_container__S5O9W","image":"ExpandCard_image__Gjfz3"};